/* JOINMELI - Kisiye ozel ucret satirini urunle esitler. 12.10.26
 * Ana urun satirinda _ozel_id ve _ozel_ucret ozellikleri vardir.
 * Ucret satiri (kisiye-ozel-hazirlik) _ozel_icin ile ana satira baglidir
 * ve her zaman ana satirin adedi kadar olur. */
(function () {
  if (window.__meliOzelSync) return;
  window.__meliOzelSync = true;
  var FEE_HANDLE = 'kisiye-ozel-hazirlik';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false, again = false, timer = null;

  function json(url, body) {
    return fetch(root + url, body ? {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    } : { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function refreshUI() {
    if (window.FoxThemeSettings && window.FoxThemeSettings.template === 'cart') {
      window.location.reload();
      return;
    }
    /* Not: temanin cart:refresh olayi cekmeceyi ic ice kopyaliyor; onun yerine
       cekmecenin kendi renderContents fonksiyonu kullaniliyor. */
    var drawer = document.querySelector('cart-drawer');
    Promise.all([
      fetch(root + '?sections=cart-drawer').then(function (r) { return r.json(); }),
      json('cart.js')
    ]).then(function (res) {
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections: res[0], item_count: res[1].item_count }, true, false);
      }
      try {
        if (window.FoxThemeCartHelpers) window.FoxThemeCartHelpers.updateCartCount(res[1].item_count);
      } catch (e) {}
    }).catch(function (e) { console.error('meli-ozel', e); });
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    json('cart.js').then(function (cart) {
      var mains = {}, fees = {};
      cart.items.forEach(function (it) {
        var p = it.properties || {};
        if (it.handle === FEE_HANDLE) {
          fees[p._ozel_icin || ('x' + it.key)] = it;
        } else if (p._ozel_id) {
          mains[p._ozel_id] = it;
        }
      });
      var updates = {}, adds = [], changed = false;
      Object.keys(fees).forEach(function (k) {
        var want = mains[k] ? mains[k].quantity : 0;
        if (fees[k].quantity !== want) { updates[fees[k].key] = want; changed = true; }
      });
      Object.keys(mains).forEach(function (k) {
        if (!fees[k] && mains[k].properties._ozel_ucret) {
          adds.push({ id: Number(mains[k].properties._ozel_ucret), quantity: mains[k].quantity, properties: { _ozel_icin: k } });
          changed = true;
        }
      });
      if (!changed) return false;
      var p = Promise.resolve();
      if (Object.keys(updates).length) p = p.then(function () { return json('cart/update.js', { updates: updates }); });
      if (adds.length) p = p.then(function () { return json('cart/add.js', { items: adds }); });
      return p.then(function () { return true; });
    }).then(function (changed) {
      if (changed) refreshUI();
    }).catch(function (e) {
      console.error('meli-ozel', e);
    }).finally(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  function start() {
    try {
      if (window.FoxThemeEvents && window.PUB_SUB_EVENTS) {
        window.FoxThemeEvents.subscribe(window.PUB_SUB_EVENTS.cartUpdate, schedule);
      }
    } catch (e) {}
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('product-ajax:added', schedule);
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
